import {React, useEffect, useState} from "react";
import classes from "./Home.module.css";
import Header from "../Header/Header";
import Banner from "../Body/Banner/Banner"


import { WhoAreWe } from "../Body/WhoAreWe/WhoAreWe";
import RBExclusive from "../Body/RBExlusive/RBExlusive";

import BookCustomization from "../Body/BookCustomization/BookCustomization";

import FeaturedCollection from "../Body/FeaturedCollection/FeaturedCollection";

import BestAuthors from "../Body/BestAuthors/BestAuthors";

import StatisticsBanner from "../Body/StatisticsBanner/StatisticsBanner";
import Gallery from "../Body/Gallery/Gallery";
import CustomerReview from "../Body/CustomerReview/CutomerReview";
import ExploreAuthors from "../Body/ExploreAuthors/ExploreAuthors";

import BlogsSection from "../Body/BlogSection/BlogSection";

import FAQRedirect from "../Body/FAQRedirect/FAQRedirect";

import Footer from "../Footer/Footer";

import { FeatureVideo } from "../Body/FeatureVideo/FeatureVideo";
import CountrySelect from "../Header/CountrySelect/CountrySelect";
import SearchComponent from "../Body/Banner/SearchComponent/SearchComponent";
import useScreenSize from "../../Hooks/UseScreenSize";
import MobileHeader from "../Body/Banner/MobileHeader/MobileHeader";
import SEO from "../../Components/SEO";

function Home() {
  const urlParams = new URLSearchParams(window.location.search);
  const referralCode = urlParams.get("referral_code"); 
  if (referralCode) {
    localStorage.setItem("referral_code", referralCode);
  }
  const { isMediumScreen } = useScreenSize();
  const [showModal, setShowModal] = useState(true);
  
  // This runs on component unmount
  useEffect(() => {
    return () => {
      // When navigating away, set a flag to skip the modal on internal navigation
      sessionStorage.setItem("skipModalOnce", "true");
    };
  }, []);
  
  // This runs after the component mounts
  useEffect(() => {
    // Check if we should skip showing the modal this time
    // (happens when navigating between pages, not on refresh)
    if (sessionStorage.getItem("skipModalOnce") === "true") {
      setShowModal(false);
      // Remove the flag so it shows on next page refresh
      sessionStorage.removeItem("skipModalOnce");
    }
  }, []);

  const defaultSEO = {
    defaultTitle: 'Rare Biblio | Leather-Bound Books, PDF to Print, Restoration',
    defaultDescription: "Explore Rare Biblio’s custom leather-bound books, expert PDF-to-print & book restoration services. Perfect for collectors, gifting & timeless bookshelf charm. ",
    defaultCanonicalUrl: 'https://rarebiblio.com/',
    keywords: "Rare Books"
  };

  return (
    <main className={classes.main}>
        <SEO structuredData={{
        "@context": "https://schema.org",
        "@type": "WebSite",
        "name": "Rare Biblio",
        "alternateName": "Rare Biblio",
        "url": "https://www.rarebiblio.com/",
        "publisher": {
          "@type": "Organization",
          "name": "Rare Biblio",
          "logo": {
            "@type": "ImageObject",
            "url": "https://www.rarebiblio.com/Assets/Icons/logo.jpg"
          }
        },
        "sameAs": [
          "https://www.facebook.com/rarebiblio/",
          "https://www.instagram.com/Rarebiblio/",
          "https://www.linkedin.com/company/Rarebiblio",
          "https://in.pinterest.com/rare_biblio/",
          "https://x.com/Rarebiblio"
        ]
      }} {...defaultSEO} />
      {showModal && <CountrySelect isHomeScreen showModal={showModal} setShowModal={setShowModal} />}
      <Header />
      {!isMediumScreen && (
        <div className={classes.section}>
          <SearchComponent />
        </div>
      )}
      {isMediumScreen && (
        <MobileHeader />
      )}
      <Banner />

      {isMediumScreen && (
        <div className={classes.section}>
          <SearchComponent />
        </div>
      )}
      <WhoAreWe />

      <FeatureVideo />

      <div className={classes.RBExclusiveContainer}>
        <RBExclusive />
      </div>

      <div className={classes.bookCustomizationContainer}>
        <BookCustomization />
      </div>

      <div className={classes.featuredCollectionContainer}>
        <FeaturedCollection />
      </div>

      <BestAuthors />

      <StatisticsBanner />
      <Gallery />
      <CustomerReview />

      <ExploreAuthors />
      <BlogsSection />

      <FAQRedirect />


      <div className={classes.footerSection}>
        <Footer />
      </div>
    </main>
  );
}

export default Home;



